import React from "react";
import Spinner from "components/common/Spinner";
import ClusterManagementTeaserSearch from "components/datanode/ClusterManagement/ClusterManagementTeaserSearch";
import viewJson from "components/datanode/ClusterManagement/sample-dashboards/overview_view.json";
import DynamicSearch from "./DynamicSearch";
import useIsDatanodeConfigured from "./useIsDatanodeConfigured";
import LicenseCheck from "../license/LicenseCheck";
const EnterpriseLicenseSubject = "/license/enterprise";
const ClusterManagementSearch = () => {
  const { isDatanodeConfigured, isLoading } = useIsDatanodeConfigured();
  return /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: EnterpriseLicenseSubject, displayLicenseWarning: false }, ({ licenseIsValid }) => {
    if (isLoading) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    if (licenseIsValid && isDatanodeConfigured) {
      return /* @__PURE__ */ React.createElement(DynamicSearch, { viewJson });
    }
    return /* @__PURE__ */ React.createElement(ClusterManagementTeaserSearch, null);
  });
};
export default ClusterManagementSearch;
